<div
  class="bd-search-results-tab"
  [style]="{ height: 'calc(100vh - 44px - ' + filtersHeight() + 'px)' }"
  *transloco="let t; scope: 'featureSearch'"
>
  @if (!loading() && sortedWorkspaceItems().length === 0) {
    <bd-search-tab-empty-state
      data-id="workspace-search-results-empty"
      [titleKey]="'featureSearch.tabEmptyState.noWorkspacesTitle'"
      [descriptionKey]="'featureSearch.tabEmptyState.noWorkspacesDescription'"
      [links]="emptyStateLinks()"
      (scopeSelected)="switchScope.emit($event)"
    ></bd-search-tab-empty-state>
  } @else {
    <div class="flex pt-4 justify-end pb-6 items-end gap-6">
      <bd-select
        [settings]="sortSettings"
        [selectedOption]="selectedSortOption()"
        (selectedOptionChange)="onSortChange($event)"
        data-id="workspace-sort-select"
      />

      <bd-select
        [settings]="displaySettings"
        [selectedOption]="displayOption() === 'grid' ? gridOption : listOption"
        (selectedOptionChange)="onDisplayChange($event)"
        data-id="workspace-display-select"
      />
    </div>

    <div
      class="bd-scrollable-results"
      data-id="workspace-search-results-scroll"
    >
      @if (!loading()) {
        @if (displayOption() === 'grid') {
          <bd-item-grid
            data-id="workspace-search-results"
            [items]="listItems()"
            [size]="'small'"
          ></bd-item-grid>
        } @else {
          <bd-item-view
            data-id="workspace-search-results"
            [data]="listItems()"
            [columns]="workspaceColumns()"
            [selectionMode]="'single'"
            [tScope]="'featureWorkspaces'"
            (selectedItemsChange)="onSelectedItemsChange($event)"
            (itemDoubleClick)="onItemDoubleClick($event)"
          ></bd-item-view>
        }
      } @else if (displayOption() === 'grid') {
        <bd-item-grid-loading
          data-id="loading-workspace-search-results"
          [loadingItemsCount]="pageSize()"
          [size]="'small'"
        ></bd-item-grid-loading>
      } @else {
        <bd-item-view-loading
          data-id="loading-workspace-search-results"
          [loadingItemsCount]="pageSize()"
          [columns]="workspaceColumns()"
          [tScope]="'featureWorkspaces'"
        ></bd-item-view-loading>
      }

      @if (totalCount() > pageSize()) {
        <bd-pagination
          class="bd-pagination mt-6"
          data-id="workspace-results-page"
          [currentPage]="currentPageIndex() + 1"
          [totalRecords]="totalCount()"
          [pageSize]="pageSize()"
          [paginationType]="'regular'"
          (currentPageChange)="onPageChange($event)"
        ></bd-pagination>
      }
    </div>
  }
</div>
